import styled, { css } from "styled-components";
import {
  Aggregator,
  ArrowDown,
  ArrowRight,
  ArrowUp,
  Button,
  Text,
  theme,
} from "ui";

interface BlackThemeComponent {
  isBlackTheme?: boolean;
}

interface AlsoSeeContentProps {
  collapse: boolean;
}

interface SideMenuItemsProps extends BlackThemeComponent {
  isSelected: boolean;
}

export const ArrowUpIcon = styled(ArrowUp)``;

export const ArrowDownIcon = styled(ArrowDown)``;

export const ArrowRightIcon = styled(ArrowRight).attrs({
  width: 20,
  height: 20,
})``;

export const AlsoSeeContainer = styled.div``;

export const Title = styled.h2<BlackThemeComponent>`
  font-size: 2rem;
  color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? `${theme.colors.blackFriday.white}`
      : `${theme.colors.blackFriday["115"]}`};
  font-weight: ${theme.typography.fontWeight["500"]};
`;

export const AlsoSeeContent = styled.div<AlsoSeeContentProps>`
  display: flex;
  margin: 1.115rem 0 2.08rem;

  gap: 0.5rem;
  ${({ collapse }) =>
    collapse
      ? `
        display: none;
      `
      : `
        display: flex;

        @media ${theme.device.desktopFirst.tablet} {
          flex-direction: column;
        }
        `}
`;

export const ProductsSideMenu = styled.div<BlackThemeComponent>`
  height: 100%;
  border-radius: 2px;
  border: thin solid
    ${({ isBlackTheme }) =>
      isBlackTheme
        ? `${theme.colors.blackFriday["100"]}`
        : `${theme.colors.blackFriday["30"]}`};
`;

export const TitleItem = styled.span<BlackThemeComponent>`
  font-size: 1.1rem;
  color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? `${theme.colors.blackFriday.white}`
      : `${theme.colors.blackFriday["115"]}`};
  font-weight: ${theme.typography.fontWeight["500"]};
`;

export const ProductSideMenuItem = styled.div<BlackThemeComponent>`
  width: 279px;
  background-color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? `${theme.colors.blackFriday["175"]}`
      : `${theme.colors.blackFriday.white}`};
  border-radius: 2px;
`;

export const SideMenuItems = styled.div<SideMenuItemsProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3.825rem;
  padding: 0 1rem;
  cursor: pointer;

  background-color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? `${theme.colors.blackFriday["175"]}`
      : `${theme.colors.neutral.white}`};

  ${({ isSelected, isBlackTheme }) =>
    isBlackTheme && isSelected
      ? css`
          background-color: ${theme.colors.blackFriday["100"]};

          ${TitleItem} {
            color: ${theme.colors.blackFriday.white};
          }
        `
      : isSelected &&
        css`
          background-color: ${theme.colors.blackFriday["400"]};

          ${TitleItem} {
            color: ${theme.colors.blackFriday["480"]};
          }
        `}
`;

export const CategoriesSliderWrapper = styled.div`
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  overflow-x: scroll;
  gap: 8px;
  height: fit-content;
  justify-content: start;
`;

export const ItemsTitle = styled.span<BlackThemeComponent>`
  color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? `${theme.colors.blackFriday.white}`
      : ` ${theme.colors.neutral["530"]}`};

  font-size: 1.08rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  display: -moz-box;
  -moz-box-orient: vertical;

  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CategoriesItems = styled.div<SideMenuItemsProps>`
  display: flex;
  align-items: center;
  margin: 0.6rem 0;
  height: 42px;
  text-align: center;
  padding: 0.5rem 0.83rem;
  white-space: normal;
  max-width: 205px;
  border-radius: 10px;
  background-color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? `${theme.colors.blackFriday["175"]}`
      : `${theme.colors.blackFriday.white}`};

  ${({ isSelected, isBlackTheme }) =>
    isBlackTheme && isSelected
      ? css`
          background-color: ${theme.colors.blackFriday["420"]};
        `
      : isSelected &&
        css`
          background-color: ${theme.colors.blackFriday["400"]};
        `}
`;

export const AggregatorCustom = styled(Aggregator)`
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const TextCustom = styled(Text)<BlackThemeComponent>`
  flex: 1;
  color: ${theme.colors.neutral["520"]};
  font-size: ${theme.typography.fontSize.md.x3};
  font-weight: ${theme.typography.fontWeight["500"]};
  color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? `${theme.colors.blackFriday.white}`
      : `${theme.colors.neutral["520"]}`};

  @media ${theme.device.desktopFirst.tablet} {
    font-size: 1.5rem;
    padding-left: ${theme.space["x2.5"]};
  }
`;

export const ButtonCustom = styled(Button)<BlackThemeComponent>`
  width: 100%;
  box-shadow: 0px 3px 6px ${theme.colors.neutral["999-opacity-10"]};
  padding: ${theme.space.x1};
  background-color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? `${theme.colors.blackFriday["175"]}`
      : `${theme.colors.blackFriday.white}`};
  border: thin solid
    ${({ isBlackTheme }) =>
      isBlackTheme
        ? `${theme.colors.blackFriday["100"]}`
        : `${theme.colors.neutral["95"]}`};
  border-radius: 2px;
  -webkit-tap-highlight-color: transparent !important;

  &:hover {
    background-color: initial;
  }
`;

export const SkeletonContainer = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.space.x2};
`;
